/* eslint-disable */
import _ from 'underscore';
import * as _SharedEditorView from '@bingads-webui-campaign-legacy/adextension-shared/view/extension-editor';
var schema = window.globalLegacySchema.get('ReviewAdExtension');
var SharedEditorView = _SharedEditorView.default;
var EditorView = SharedEditorView.extend({
  initialize: function (options) {
    options = _.extend(options || ({}), {
      schema: schema,
      fields: [{
        property: 'IsExact',
        control: 'inline-radios',
        values: [false, true]
      }, 'Text', 'Source', 'Url']
    });
    SharedEditorView.prototype.initialize.call(this, options);
  }
});
export default EditorView;

